import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalProps,
  Switch,
  Image,
} from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';
import { themeVariables } from '../theme';

const minswapSrc =
  'https://sqvzfgobtlzbovqbkaax.supabase.co/storage/v1/object/public/sdk-assets//minswap_horizontal.svg';

const SETTINGS = {
  MINSWAP: {
    title: (
      <Flex color="white" fontSize="0.875rem" gap={2}>
        Zap-in via <Image src={minswapSrc} alt="minswap" width={85} />
      </Flex>
    ),
    description:
      'Metera orders require you to deposit the underlying assets yourself. To obtain the necessary assets for minting MTKs, you can swap directly with one of our providers',
  },
  SWAP_DEFICIT: {
    title: 'Swap Only Missing Tokens',
    description:
      'If turned on, Minswap will only swap the difference between assets required for your Metera Order and your balance.',
  },

  ORDER_PROTECTION: {
    title: 'Metera Order Protection',
    description:
      'Buy extra tokens to cover potential changes in asset requirements during order processing. Unused assets stay in your wallet.',
  },
};

interface SettingControlProp {
  value: boolean;
  setValue: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
}

export const SettingsModal = ({
  children,
  minWidth = 'fit-content',
  minHeight = 'fit-content',
  padding = undefined,
  background = '#08040f',
  controls,
  ...rest
}: ModalProps & {
  minWidth?: string;
  minHeight?: string;
  padding?: string;
  background?: string;
  hasInsufficientToken?: boolean;
  controls: Partial<Record<keyof typeof SETTINGS, SettingControlProp>>;
}) => (
  <Modal isCentered {...rest}>
    <ModalOverlay />{' '}
    <ModalContent
      background={background}
      minHeight={minHeight}
      transition={'0.2s'}
      minWidth="30rem"
      padding="1rem"
      borderRadius={'0.75rem'}
      sx={{
        backdropFilter: 'blur(60px)',
        maxWidth: '30rem !important',
      }}
    >
      <ModalBody>
        <Flex flexDir="column" width="100%" height="100%" gap="0.5rem">
          <Flex justify="space-between">
            <Box color="white" fontSize="1rem" fontWeight={500}>
              Order Settings
            </Box>
            <Box as="button">
              <img></img>
            </Box>
          </Flex>

          {Object.entries(SETTINGS).map(([key, { title, description }]) => {
            const { value, setValue, disabled } = controls[
              key as keyof typeof SETTINGS
            ] || { value: true, setValue: () => {}, disabled: true };
            return (
              <Flex flexDir="column" gap="0.2rem" key={key}>
                <Flex
                  justify="space-between"
                  align="center"
                  alignContent="center"
                >
                  <Box color="white" fontSize="0.875rem">
                    {title}
                  </Box>
                  <Switch
                    sx={{
                      '.chakra-switch__track': {
                        bg: '#ccc',
                      },
                      '.chakra-switch__thumb': {
                        bg: 'white',
                      },
                      '&[data-checked] .chakra-switch__track': {
                        bg: '#e8a92d',
                      },
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    checked={value}
                    defaultChecked={value}
                    onChange={(e) => setValue(e.target.checked)}
                    disabled={disabled}
                  />
                </Flex>
                <Box fontSize="0.875rem" color="#a3a3a3">
                  {description}
                </Box>
              </Flex>
            );
          })}
        </Flex>
      </ModalBody>
    </ModalContent>
  </Modal>
);
